import { defineComponent, defineAsyncComponent, ref, onMounted, onBeforeUnmount, openBlock, createElementBlock, createVNode, unref, normalizeClass, withCtx, createElementVNode, createBlock, mergeProps, createCommentVNode, normalizeStyle, createTextVNode, toDisplayString, resolveDynamicComponent, Transition } from "vue";
import { CdrContainer, CdrBreadcrumb } from "@rei/cedar";
import ClientOnly from "../ClientOnly/ClientOnly.mjs";
import BelowTheFoldContainer from "../../containers/BelowTheFoldContainer/BelowTheFoldContainer.mjs";
import AddToCartSticky from "../AddToCartSticky/AddToCartSticky.mjs";
import PupNotice from "../PupNotice/PupNotice.mjs";
import RrRecs from "../RrRecs/RrRecs.mjs";
const _hoisted_1 = ["data-cnstrc-item-id", "data-cnstrc-item-name", "data-cnstrc-item-price", "data-cnstrc-item-variation-id"];
const _hoisted_2 = {
  class: "product-page__top-full-content"
};
const _hoisted_3 = {
  class: "product-page__media-center product-page__media-center--grid-layout"
};
const _hoisted_4 = {
  class: "product-page__media-center-sticky-content"
};
const _hoisted_5 = {
  class: "product-page__atc-sentinel-wrapper"
};
const _hoisted_6 = {
  ref: "atcSticky",
  class: "product-page__atc-sticky-wrapper"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductPage",
  props: {
    addToCartStickyProps: {},
    ariaLive: {},
    breadcrumbs: {},
    c9rProductDetail: {},
    flairBadge: {},
    isPup: {
      type: Boolean
    },
    modalContainer: {},
    pupNotice: {},
    rrRecsProps: {},
    showPupNotice: {
      type: Boolean
    },
    showRecs: {
      type: Boolean
    },
    showAtcSticky: {
      type: Boolean
    },
    showXlBreakpoint: {
      type: Boolean
    }
  },
  emits: ["addToCart", "metricsClick", "recsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const AriaAnnouncer = defineAsyncComponent(() => import("@rei/aria-announcer"));
    const BuyBoxContainer = defineAsyncComponent(() => import("../../containers/BuyBoxContainer/index.mjs"));
    const MediaCenterContainer = defineAsyncComponent(() => import("../../containers/MediaCenterContainer/index.mjs"));
    const HeaderContainer = defineAsyncComponent(() => import("../../containers/HeaderContainer/index.mjs"));
    const props = __props;
    const emit = __emit;
    const atcObserver = ref();
    const productPageObserver = ref();
    const buyBoxObserver = ref();
    const buyBoxInView = ref(false);
    const pageRootInView = ref(false);
    const atcStickyViewed = ref(false);
    const fullBuyBoxVisible = ref(true);
    const buyBox = ref(null);
    const atcSentinel = ref(null);
    const productPageRoot = ref(null);
    const bbSticky = ref(null);
    const atcObserverCB = (entries) => {
      entries.forEach((entry) => {
        buyBoxInView.value = entry.isIntersecting || entry.boundingClientRect.top > 0;
        if (!atcStickyViewed.value && props.showAtcSticky && !buyBoxInView.value && pageRootInView) {
          atcStickyViewed.value = true;
        } else if (!atcStickyViewed.value && !props.showAtcSticky && !buyBoxInView.value) {
          atcStickyViewed.value = true;
        }
      });
    };
    const productPageObserverCB = (entries) => {
      entries.forEach((entry) => {
        pageRootInView.value = entry.isIntersecting;
      });
    };
    const buyBoxObserverCB = (entries) => {
      entries.forEach((entry) => {
        fullBuyBoxVisible.value = entry.intersectionRatio === 1;
      });
    };
    const scrollToBuyBox = () => {
      var _a;
      (_a = buyBox == null ? void 0 : buyBox.value) == null ? void 0 : _a.scrollIntoView({
        behavior: "smooth"
      });
    };
    onMounted(() => {
      atcObserver.value = new window.IntersectionObserver(atcObserverCB);
      if (atcSentinel.value) atcObserver.value.observe(atcSentinel == null ? void 0 : atcSentinel.value);
      productPageObserver.value = new window.IntersectionObserver(productPageObserverCB);
      if (productPageRoot.value) productPageObserver.value.observe(productPageRoot == null ? void 0 : productPageRoot.value);
      buyBoxObserver.value = new window.IntersectionObserver(buyBoxObserverCB, {
        threshold: [0, ...Array.from({
          length: 10
        }, (x, i) => (i + 1) / 10)]
      });
      if (bbSticky.value) buyBoxObserver.value.observe(bbSticky == null ? void 0 : bbSticky.value);
    });
    onBeforeUnmount(() => {
      var _a, _b, _c;
      (_a = atcObserver.value) == null ? void 0 : _a.disconnect();
      (_b = productPageObserver.value) == null ? void 0 : _b.disconnect();
      (_c = buyBoxObserver.value) == null ? void 0 : _c.disconnect();
    });
    const handleBreadcrumbsClick = (crumb, event) => {
      emit("metricsClick", {
        linkName: "breadcrumb",
        link: crumb.item.url,
        event
      });
    };
    return (_ctx, _cache) => {
      var _a, _b, _c, _d;
      return openBlock(), createElementBlock("div", {
        id: "page-body",
        ref_key: "productPageRoot",
        ref: productPageRoot,
        "data-cnstrc-product-detail": "",
        "data-cnstrc-item-id": (_a = _ctx.c9rProductDetail) == null ? void 0 : _a.itemId,
        "data-cnstrc-item-name": (_b = _ctx.c9rProductDetail) == null ? void 0 : _b.itemName,
        "data-cnstrc-item-price": (_c = _ctx.c9rProductDetail) == null ? void 0 : _c.itemPrice,
        "data-cnstrc-item-variation-id": (_d = _ctx.c9rProductDetail) == null ? void 0 : _d.itemVariationId
      }, [createVNode(unref(CdrContainer), {
        class: normalizeClass(["product-page", _ctx.showXlBreakpoint && "product-page__xl"])
      }, {
        default: withCtx(() => {
          var _a2, _b2;
          return [createElementVNode("div", _hoisted_2, [createVNode(unref(CdrBreadcrumb), {
            id: "product-page-breadcrumbs",
            class: "product-page__breadcrumbs",
            items: _ctx.breadcrumbs,
            onNavigate: handleBreadcrumbsClick
          }, null, 8, ["items"]), _ctx.showPupNotice ? (openBlock(), createBlock(unref(PupNotice), mergeProps({
            key: 0,
            class: "product-page__pup-notice"
          }, _ctx.pupNotice, {
            onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data))
          }), null, 16)) : createCommentVNode("", true), _ctx.showRecs && _ctx.isPup && !_ctx.showPupNotice ? (openBlock(), createBlock(unref(RrRecs), mergeProps({
            key: 1
          }, _ctx.rrRecsProps, {
            class: "product-page__rr--pup",
            onRecsClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("recsClick", data)),
            onMetricsClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("metricsClick", data))
          }), null, 16)) : createCommentVNode("", true)]), createElementVNode("div", _hoisted_3, [_ctx.flairBadge ? (openBlock(), createElementBlock("div", {
            key: 0,
            class: "product-page__flair-badge",
            style: normalizeStyle(((_a2 = _ctx.flairBadge) == null ? void 0 : _a2.color) ? {
              color: _ctx.flairBadge.color
            } : null)
          }, [createTextVNode(toDisplayString(_ctx.flairBadge.title) + " ", 1), createElementVNode("span", {
            class: "product-page__flair-badge--underline",
            style: normalizeStyle(((_b2 = _ctx.flairBadge) == null ? void 0 : _b2.color) ? {
              "border-top": `4px solid ${_ctx.flairBadge.color}`
            } : null)
          }, null, 4)], 4)) : createCommentVNode("", true), createElementVNode("div", _hoisted_4, [createVNode(unref(MediaCenterContainer))])]), createElementVNode("div", {
            ref_key: "buyBox",
            ref: buyBox,
            class: "product-page__buy-box-sticky-container"
          }, [createElementVNode("div", {
            ref_key: "bbSticky",
            ref: bbSticky,
            class: normalizeClass(["product-page__buy-box-sticky-content", fullBuyBoxVisible.value ? "product-page__buy-box-sticky-content--stick-top" : null])
          }, [createVNode(unref(HeaderContainer), {
            class: "product-page__product-header product-page__product-header--grid-layout"
          }), createVNode(unref(BuyBoxContainer), {
            class: "product-page__buy-box"
          }), createElementVNode("div", _hoisted_5, [createElementVNode("div", {
            ref_key: "atcSentinel",
            ref: atcSentinel,
            class: "product-page__atc-sentinel"
          }, null, 512)])], 2)], 512), createVNode(unref(ClientOnly), null, {
            default: withCtx(() => [_ctx.showRecs && (!_ctx.isPup || _ctx.showPupNotice) ? (openBlock(), createBlock(unref(RrRecs), mergeProps({
              key: 0
            }, _ctx.rrRecsProps, {
              class: "product-page__rr",
              onRecsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("recsClick", data)),
              onMetricsClick: _cache[4] || (_cache[4] = (data) => _ctx.$emit("metricsClick", data))
            }), null, 16)) : createCommentVNode("", true)]),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["class"]), createVNode(unref(CdrContainer), {
        class: normalizeClass(["product-page__below-the-fold", _ctx.showXlBreakpoint && "product-page__below-the-fold--xl"])
      }, {
        default: withCtx(() => [createVNode(unref(BelowTheFoldContainer)), _cache[7] || (_cache[7] = createElementVNode("div", {
          id: "pdp-micro-site"
        }, null, -1)), (openBlock(), createBlock(resolveDynamicComponent(_ctx.modalContainer), {
          "modal-class": "product-page__modal-content",
          class: "product-page__modal-content"
        })), createVNode(unref(ClientOnly), null, {
          default: withCtx(() => [createVNode(unref(AriaAnnouncer), mergeProps({
            class: "pdp-sr-only"
          }, _ctx.ariaLive), null, 16)]),
          _: 1
        }), createElementVNode("div", _hoisted_6, [createVNode(Transition, {
          name: "sticky"
        }, {
          default: withCtx(() => [_ctx.showAtcSticky && !buyBoxInView.value && pageRootInView.value ? (openBlock(), createBlock(unref(AddToCartSticky), mergeProps({
            key: 0,
            class: "product-page__atc-sticky"
          }, _ctx.addToCartStickyProps, {
            onAddToCart: _cache[5] || (_cache[5] = (data) => _ctx.$emit("addToCart", data)),
            onSelectOptions: scrollToBuyBox,
            onMetricsClick: _cache[6] || (_cache[6] = (data) => _ctx.$emit("metricsClick", data))
          }), null, 16)) : createCommentVNode("", true)]),
          _: 1
        })], 512)]),
        _: 1,
        __: [7]
      }, 8, ["class"])], 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductPage2.mjs.map
